//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import func from '@/utils/preload';
export default {
  name: 'ProcessData',
  components: {
    promoterDrawer: function promoterDrawer() {
      return import('@/components/workFlow/drawer/promoterDrawer');
    },
    approverDrawer: function approverDrawer() {
      return import('@/components/workFlow/drawer/approverDrawer');
    },
    copyerDrawer: function copyerDrawer() {
      return import('@/components/workFlow/drawer/copyerDrawer');
    },
    conditionDialog: function conditionDialog() {
      return import('@/components/develop/conditionDialog');
    },
    errorDialog: function errorDialog() {
      return import('@/components/workFlow/dialog/errorDialog');
    }
  },
  props: {
    tabName: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    conf: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      tipList: [],
      curd_id: '',
      // 实体id
      tipVisible: false,
      nowVal: 100,
      lowCode: 'lowCode',
      directorMaxLevel: 10,
      nodeConfig: {
        nodeName: '申请人',
        type: 0,
        onlyValue: this.$func.onlyValue(),
        priorityLevel: '',
        settype: '',
        selectMode: '',
        selectRange: '',
        directorLevel: '',
        examineMode: '',
        noHanderAction: '',
        examineEndDirectorLevel: '',
        ccSelfSelectFlag: '',
        conditionList: [],
        nodeUserList: {
          depList: [],
          userList: []
        },
        childNode: {
          nodeName: '审核人',
          error: false,
          type: '1',
          onlyValue: this.$func.onlyValue(),
          settype: '2',
          selectMode: '0',
          selectRange: '0',
          directorLevel: '1',
          directorOrder: '1',
          examineMode: '3',
          noHanderAction: '2',
          examineEndDirectorLevel: '0',
          childNode: {
            nodeName: '抄送人',
            type: 2,
            onlyValue: this.$func.onlyValue(),
            ccSelfSelectFlag: '1',
            childNode: null,
            departmentHead: [],
            nodeUserList: [],
            error: false
          },
          nodeUserList: []
        },
        conditionNodes: []
      },
      flowPermission: {
        depList: [],
        userList: []
      },
      processConfig: {},
      isTried: false,
      tableId: '999'
    };
  },
  beforeCreate: function beforeCreate() {
    this.$vue.prototype.$func = func;
  },
  watch: {
    conf: {
      handler: function handler(val) {
        this.nodeConfig = val;
        this.flowPermission = this.nodeConfig.nodeUserList;
        this.getData();
      },
      deep: true
    },
    id: {
      handler: function handler(val) {
        if (val) {
          this.curd_id = val;
        }
      }
    }
  },
  methods: {
    reErr: function reErr(_ref) {
      var childNode = _ref.childNode;
      if (childNode) {
        var _childNode = childNode,
          type = _childNode.type,
          error = _childNode.error,
          nodeName = _childNode.nodeName,
          conditionNodes = _childNode.conditionNodes;
        if (type == 1 || type == 2) {
          if (error) {
            this.tipList.push({
              name: nodeName,
              types: 1,
              type: ['', '审核人', '抄送人'][type]
            });
          }
          this.reErr(childNode);
        } else if (type == 3) {
          this.reErr(childNode);
        } else if (type == 4) {
          this.reErr(childNode);
          for (var i = 0; i < conditionNodes.length; i++) {
            if (conditionNodes[i].error) {
              this.tipList.push({
                name: conditionNodes[i].nodeName,
                types: 1,
                type: ' 条件'
              });
            }
            if (!conditionNodes[i].childNode) {
              this.tipList.push({
                name: conditionNodes[i].nodeName,
                types: 2,
                type: ' 审批人或抄送人'
              });
            }
            this.reErr(conditionNodes[i]);
          }
        }
      } else {
        childNode = null;
      }
    },
    getData: function getData() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.isTried = true;
        _this.tipList = [];
        if (!_this.nodeConfig.childNode) {
          _this.tipList.push({
            name: '',
            types: 2,
            type: ' 审批人或抄送人'
          });
        }
        _this.reErr(_this.nodeConfig);
        _this.nodeConfig.nodeUserList = _this.flowPermission;
        resolve(_this.nodeConfig);
      });
    },
    zoomSize: function zoomSize(type) {
      if (type == 1) {
        if (this.nowVal === 50) {
          return;
        }
        this.nowVal -= 10;
      } else {
        if (this.nowVal === 300) {
          return;
        }
        this.nowVal += 10;
      }
    }
  }
};